import { render, staticRenderFns } from "./BaseItemPicker.vue?vue&type=template&id=6a8c5b44&scoped=true"
import script from "./BaseItemPicker.vue?vue&type=script&lang=js"
export * from "./BaseItemPicker.vue?vue&type=script&lang=js"
import style0 from "./BaseItemPicker.vue?vue&type=style&index=0&id=6a8c5b44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8c5b44",
  null
  
)

export default component.exports